import { getApiErrorInfo } from "../../api/apiError";

// The request_id of a failed request, as a small muted line under the error
// message, for the user to quote to support so the matching server log line
// can be found. `error` is a thrown error or getApiErrorInfo()'s result.
// Renders nothing when there's no request id (a plain string message, a
// network failure, a legacy connector).
export default function ErrorReference({
  error,
  className = "text-muted mt-1",
  style,
}) {
  const { requestId } = getApiErrorInfo(error);
  if (!requestId) return null;
  return (
    <div className={className} style={{ fontSize: "0.75rem", ...style }}>
      Reference: <span className='font-monospace user-select-all'>{requestId}</span>
    </div>
  );
}

// An error's message with its reference underneath. `error` is either a
// plain string (e.g. a client-side validation message) or
// getApiErrorInfo()'s result for a failed request.
export function ErrorText({ error }) {
  if (!error) return null;
  return (
    <>
      {typeof error === "string" ? error : error.message}
      <ErrorReference error={error} />
    </>
  );
}
